import React from "react";
import "./statCard.css";

export const StatCard = ({ title, value, netSale, grossSale }) => {
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return "-";
    return `₹${amount.toLocaleString("en-IN")}`;
  };

  const isOverdue = title === "Overdue" && value > 0;

  return (
    <div className="statCardMain">
      <div className="statCardDiv">
        <p className="statCardTitle">{title}</p>

        {title === "Current Month Sale Value" ? (
          <div className="statCardLabelDivWrapper">
            <div className="statCardLabelDiv">
              <p className="statCardLabel">NET SALE</p>
              <p className="statCardLabelValue">{formatCurrency(netSale)}</p>
            </div>
            <div className="statCardLabelDiv">
              <p className="statCardLabel">GROSS SALE</p>
              <p className="statCardLabelValue">{formatCurrency(grossSale)}</p>
            </div>
          </div>
        ) : (
          <p className="statCardValue" style={isOverdue ? { color: "#ef4444" } : undefined}>
            {title === "Quantity"
              ? value?.toLocaleString("en-IN")
              : typeof value === "number"
              ? formatCurrency(value)
              : value || "-"}
          </p>
        )}
      </div>
    </div>
  );
};